import { eIcon } from "../../components/Icon";

const Party = {
  t1: eIcon.GNB,
  t2: eIcon.PLD,
  h1: eIcon.WHM,
  h2: eIcon.SCH,
  m1: eIcon.SAM,
  m2: eIcon.NIN,
  r1: eIcon.DNC,
  r2: eIcon.RDM
}

export default Party;